import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import useLocalStorage from "./Utility/Local";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import Layout from "./Utility/layout";
import Home from "./Components/Pages/Home/Home";
import Branch from "./Components/Pages/Branch/Branch";
import Role_list from "./Components/Pages/Role/Role_list";
import User_list from "./Components/Pages/User/User_list";
import Warehouse_list from "./Components/Pages/Warehouse/Warehouse_list";
import Category_list from "./Components/Pages/Category/Category_list";
import Subcategory_list from "./Components/Pages/Subcategory/Subcategory_list";
import ItemCategory_list from "./Components/Pages/ItemCategory/ItemCategory_list";
import Item_list from "./Components/Pages/Item/Item_list";
import ItemPurchase from "./Components/Pages/Item/ItemPurchase";
import AddItemPurchase from "./Components/Pages/Item/AddItemPurchase";
import ItemSales from "./Components/Pages/Item/ItemSales";
import ItemStock_list from "./Components/Pages/Item/ItemStock_list";
import ItemSalesList from "./Components/Pages/Item/ItemSalesList";
import ItemSalesReturnList from "./Components/Pages/Item/ItemSalesReturnList";
import ItemPurchaseReturnList from "./Components/Pages/Item/ItemPurchaseReturnList";
import Supplier_list from "./Components/Pages/Suppliers/Supplier_list";
import Supplier_receipt1 from "./Components/Pages/Suppliers/Supplier_receipt";
import Supplier_details1 from "./Components/Pages/Suppliers/Suppliercreditdetails";
import Product_list from "./Components/Pages/Product/Product_list";
import Product_polo_list from "./Components/Pages/Product/Product_profitlose";
import CompanyReport from "./Components/Pages/Account/new/CompanyReport";
import ProductQty_list from "./Components/Pages/Product Quantity/ProductQty_list";
import Calender from "./Components/Pages/Calender/Calender";
import Customers_list from "./Components/Pages/Customers/Customers";
import Customersre from "./Components/Pages/Customers/Customer_receipt";
import Customers_details from "./Components/Pages/Customers/Customerdetails";
import Manufacturers_list from "./Components/Pages/Manufacturers/Manufacturers";
import Chat from "./Components/Pages/Chat/Chat";
import Brand from "./Components/Pages/Brand/Brand";
import Purchase from "./Components/Pages/Purchase/Purchase";
import AddPurchase from "./Components/Pages/Purchase/AddPurchase";
import EditPurchase from "./Components/Pages/Purchase/EditPurchase";
import PurchaseInventory from "./Components/Pages/Purchase/PurchaseInventory";
import PurchasePDF from "./Components/Pages/Purchase/PurchasePDF";
import QuotationPDF from "./Components/Pages/Quotation/QuotationPDF";
import Log from "./Components/Pages/Login/Login2";
import Quotation_list from "./Components/Pages/Quotation/Quotation_list";
import AddQuotation from "./Components/Pages/Quotation/AddQuotation";
import EditQuotation from "./Components/Pages/Quotation/EditQuotation";
import SalesWindow from "./Components/Pages/SalesWindow/SalesWindow";
import ReturnList from "./Components/Pages/SalesWindow/ReturnList";
import SalesList from "./Components/Pages/SalesWindow/SalesList";
import FinanceList from "./Components/Pages/Finance/FinanceList";
import Units_list from "./Components/Pages/Units/Units_list";
import SalesDetail from "./Components/Pages/SalesWindow/SalesDetails";
import Taxes_list from "./Components/Pages/Taxes/Taxes_list";
import Documents_type from "./Components/Pages/Documents Type/DocumentsType";
import DocumentTable from "./Components/Pages/Documents Table/documentsTable"
import Documents_Details from "./Components/Pages/Documnets Details/documentDetails";
import Menu from "./Components/Pages/Home/Menu";
import CreditReceipt from "./Components/Pages/CreditReceipt/CreditReceipt";
import Findsales from "./Components/Pages/SalesWindow/Findsale";
import BranchList from "./Components/Pages/Branch/list_branch";
import Employee from "./Components/Pages/Employee/Employee";
import ParentCompany from "./Components/Pages/Company/ParentCompany";
import Reports from "./Components/Pages/Reports/Reports";
import Projectandexpenses from "./Components/Pages/ProjectandExpenses/Projectandexpenses1";
import Projectview from "./Components/Pages/ProjectandExpenses/projectview";
import Account from "./Components/Pages/Account/Account";
import Emp_report from "./Components/Pages/Reports/Emp_report";
import inexpe_report from "./Components/Pages/Reports/inexpe_report";
import Stock_report from "./Components/Pages/Reports/stock_report";
import Creditdebit_report from "./Components/Pages/Reports/creditdebit_report";
import Projectsall from "./Components/Pages/ProjectandExpenses/Projectpage";
import Clinet from "./Components/Pages/ProjectandExpenses/Client/Clinet";
// import SalesReport from "./Components/Pages/Reports/SalesReport";
import SalesReport from "./Components/Pages/Reports/new/SalesReport";
import Expiry_report from "./Components/Pages/Reports/Expire_report";
import Inventory from "./Components/Pages/Inventory/Inventory";
import Project_todo from "./Components/Pages/ProjectandExpenses/Todo-list/Todolist";
import Expense from "./Components/Pages/Account/Expense";
import Accountlist from "./Components/Pages/Account/Accounts_list";
import UserDocument from "./Components/Pages/User/UserDocument";
import Client_Feedback from "./Components/Pages/ProjectandExpenses/Client/Client_feedback";
import PurchaseOrder from "./Components/Pages/PurchaseOrder/PurchaseOrder";
import AddPurchaseOrder from "./Components/Pages/PurchaseOrder/AddPurchaseOrder";
import Services from "./Components/Pages/ProjectandExpenses/Services/Services";
import TaskTimer from "./Components/Pages/TaskTimer/TaskTimer";
import ServicesExpense from "./Components/Pages/ProjectandExpenses/Services/ServicesExpense";
import TaskTimerDetail from "./Components/Pages/TaskTimer/TaskTimerDetail";
import ServicesDetails from "./Components/Pages/ProjectandExpenses/ServiceDetails/ServicesDetails";
import PrintComponent from "./Components/Pages/AAPrintComponent/PrintComponent";
import BarCodeScreen from "./Components/Pages/BarCode/BarCodeScreen";
import ShopsBranch from "./Components/Pages/Shops/ShopsBranch";
import SubCompany from "./Components/Pages/Shops/SubCompany";
import DocumentExpiry from "./Components/Pages/Expiry/DocumentExpiry";
import ProjectEmployeeReport from "./Components/Pages/ProjectandExpenses/ProjectEmployeeReport";
import Expiry from "./Components/Pages/product_expiry/Expiry";
import ProfitLoss_report from "./Components/Pages/Reports/ProfitLoss_report";
// import SupplierTransaction from "./Components/Pages/Reports/SupplierTransaction";
import SupplierTransaction from "./Components/Pages/Reports/new/SupplierTransaction";
import CustomerTransaction from "./Components/Pages/Reports/new/CustomerTransaction";
import FinanceReport from "./Components/Pages/Reports/new/FinanceReport";
// import PurchaseReport from "./Components/Pages/Reports/PurchaseReport";
import PurchaseReport from "./Components/Pages/Reports/new/PurchaseReport";
import DailySalesReport from "./Components/Pages/Reports/Daily_sales_report";
import DailysalesReportDetails from "./Components/Pages/Reports/DailysalesReportDetails";
import ServiceTransaction from "./Components/Pages/Reports/ServiceTransaction";
import ServiceReport from "./Components/Pages/Reports/ServiceReport";
import CRMMenu from "./Components/Pages/CRM/CRMMenu";
import EmployeeManagement from "./Components/Pages/Home/EmployeeManagement";
import Emaillog from "./Components/Pages/Login/Emaillog";
import SalesReport_PDF from "./Components/Pages/Reports/SalesReport_PDF";
import shopdata from "./Components/Pages/Shops/shopdata";
import Termsandcondiitons from "./Components/Pages/Terms/Termsandcondiitons";
import Return from "./Components/Pages/Return/Return";
// full View
import Full_product from "./Components/Pages/Full_View/Product";
import Full_sales from "./Components/Pages/Full_View/Sales";
import Full_purchase from "./Components/Pages/Full_View/Purchase";
import Full_customer from "./Components/Pages/Full_View/Customer";
import Full_supplier from "./Components/Pages/Full_View/Supplier";
import PurchaseReturn from "./Components/Pages/Purchase/PurchaseReturn";
import Totaldailyreport from "./Components/Pages/Reports/Totaldailyreport";
import ReturnListorder from "./Components/Pages/SalesWindow/ReturnListorder";
import RMSalesList from "./Components/Pages/SalesWindow/RMSalesList";
import RMReturnListorder from "./Components/Pages/SalesWindow/RMReturnListorder";
import ProfitLossReport from "./Components/Pages/Reports/ProfitLossReport";
import MonthlyProfitLossReport from "./Components/Pages/Reports/MonthlyProfitLossReport";
import ProductSerialNo from "./Components/Pages/Product/ProductSerialNo";
import ProductPerformance from "./Components/Pages/Product/ProductPerformance";
import PurchasesReturnReport from "./Components/Pages/Purchase/PurchaseReturnReport";
import GeneralLedger from "./Components/Pages/Account/new/GeneralLedger";
import AllTransaction from "./Components/Pages/Reports/new/AllTransaction";
import StockReport from "./Components/Pages/Reports/new/StockReport";
import RawMaterialReport from "./Components/Pages/Reports/new/RawMaterialReport";
import FinishedProductReport from "./Components/Pages/Reports/new/FinishedProductReport";
import ProductTransfer from "./Components/Pages/Product/ProductTransfer";
import product_master from "./Components/Pages/Product/product_master";
import RawMaterials from "./Components/Pages/Product/RawMaterials";
import ProductProcessingList from "./Components/Pages/Product/Ingridents";
import Eproduct from "./Components/Pages/Product/Eproducts";
import Raw_transection from "./Components/Pages/Product/Raw_transection";
import Rawmaterial from "./Components/Pages/Full_View/Rawmaterial";
import product_expire from "./Components/Pages/Product/product_expire";
import Product_process from "./Components/Pages/Product/Product_process";
import Product_order from "./Components/Pages/SalesWindow/Product_order";
import RawMaterialOrder from "./Components/Pages/SalesWindow/RawMaterialOrder";
import Pod_details from "./Components/Pages/Product/Pod_details";
import { IngredientsPage } from "./Components/Pages/Product/IngredientsPage";
import { ProductDetailsPage } from "./Components/Pages/Product/ProductDetailsPage";
import { ProcessPage } from "./Components/Pages/Product/ProcessPage";
import ProductDetailTransaction from "./Components/Pages/Product/ProductDetailTransaction";
import UndistributedProducts from "./Components/Pages/Product/UndistributedProducts";
import ShareHolderList from "./Components/Pages/ShareHolder/ShareHolderList";
import ShareHolderDetails from "./Components/Pages/ShareHolder/ShareHolderDetails";
import Loanreport from "./Components/Pages/Account/new/Loanreport";
import POBatchreport from "./Components/Pages/Reports/POBatchreport";
import Shareholders from "./Components/Pages/ShareHolder/Sharehoders";
import Sharepaymentreport from "./Components/Pages/ShareHolder/Sharepaymentreport";
import SalaryList from "./Components/Salary/SalaryList";
import AdvanceReport from "./Components/Salary/AdvanceReport";
import BankLedger from "./Components/Pages/Account/new/BankLedger";
import Equity from "./Components/Pages/Account/Equity";
import Assets from "./Components/Pages/Account/Assets";



function App() {
  const [Logindata, setLogindata] = useLocalStorage("AuthUser");
  let routeList = [];

  const Common = (Component) => {
    if (!Logindata) {
      return <Navigate to="/login" replace />;
    }
    return (
      <Layout>
        <Component />
      </Layout>
    );
  };

  try {
    const parsedToken = Logindata?.user;
    if (parsedToken && parsedToken.menu_list) {
      const parsed = JSON.parse(parsedToken.menu_list);
      if (Array.isArray(parsed)) {
        routeList = parsed;
        const allowedMenus = parsed.map(item => item?.menu).filter(Boolean);
        routeList = [...routeList, ...allowedMenus];

        // Inherit permissions for nested sub-routes
        if (allowedMenus.includes("/Product_list")) {
          routeList.push(
            "/product_master",
            "/Product_master_details",
            "/e_product_process",
            "/product-detail-transaction",
            "/undistributed-products",
            "/product_expire"
          );
        }
        if (allowedMenus.includes("/raw_metrial")) {
          routeList.push("/raw_materials", "/packaging_materials", "/raw_transection", "/Rawmetrial_expiry");
        }
        if (allowedMenus.includes("/Item_list")) {
          routeList.push(
            "/ItemCategory_list",
            "/ItemPurchase",
            "/add_item_purchase",
            "/item_purchase_return_list",
            "/ItemSales",
            "/item_sales_list",
            "/item_sales_return_list",
            "/ItemStock_list"
          );
        }
        if (allowedMenus.includes("/Customers_list")) {
          routeList.push("/Customer_receipt");
        }
        if (allowedMenus.includes("/Supplier_list")) {
          routeList.push("/Supplier_receipt");
        }
        if (allowedMenus.includes("/accounts")) {
          routeList.push(
            "/bank",
            "/accounts_list",
            "/capital",
            "/assets",
            "/general-ledger",
            "/profitloss-report",
            "/monthly-profitloss-report",
            "/loan-report"
          );
        }
        if (allowedMenus.includes("/product_order")) {
          routeList.push("/raw_material_order");
        }
        if (allowedMenus.includes("/sales_list")) {
          routeList.push("/rm_sales_list", "/return_list_order", "/rm_return_list_order");
        }
        if (allowedMenus.includes("/purchase")) {
          routeList.push("/purchase-return-list");
        }
        if (allowedMenus.includes("/User_list")) {
          routeList.push("/user_list");
        }
        if (allowedMenus.includes("/reports")) {
          routeList.push(
            "/supplier-transaction",
            "/customr-transaction",
            "/all-transaction",
            "/sales_report",
            "/purchase-report",
            "/finance-report",
            "/raw-material-report",
            "/finished-product-report",
            "/pobatch-report",
            "/monthly-profitloss-report"
          );
        }
      }
    }
  } catch (error) {
    console.error("Failed to parse menu_list:", error);
  }

  routeList = [
    ...routeList,
    '/login',
    '/',
    '/dashboard',
    '/return_list',
    "/add_purchase",
    "/edit_purchase",
    "/add_quotation",
    "/purchase_pdf",
    "/add_purchase",
    "/edit_purchase",
    "/add_inventory",
    "/quotation_pdf",
    "/edit_quotation",
    "/sales_details",
    "/Menu",
    "/shops",
    "/branch_list",
    "/employee",
    "/parent_company",
    "/documentupload",
    "/reports",
    // "/projects_expenses",
    "/credit_debit_report",
    "/stocks_report",
    "/purchase-report",
    "/finance-report",
    "/income_expense_report",
    "/employee_report",
    "/expiry_items_report",
    // "/projects",
    "/clients",
    "/sales_report",
    "/inventory",
    // "/project_todo",
    "/UserDocument",
    "/Client_feedback",
    "/purchase_order",
    "/add_purchase_order",
    // "/services",
    // "/service_expenses",
    "/service_details",
    "/task_timer",
    "/task_timer_detail",
    "/Projectview",
    "/print_receipt",
    "/bar_code",
    "/Supplier_details",
    "/Customer_details",
    "/Product_profitlose",
    "/Company_accounts",
    "/sub-company",
    "/sub-companys",
    "/shops-branch",
    "/document-expiry",
    // "/projectemployeereport",
    "/profit-loss_report",
    "/supplier-transaction",
    "/customr-transaction",
    "/daily_sales_report",
    "/daily_sales-report_details",
    "/service-transaction",
    "/service-report",
    "/crm-menu",
    "/employee-management",
    "/Emaildata",
    "/SalesReport_Pdf",
    "/shopdata",
    "/terms",
    "/return",
    "/full_product",
    "/full_sales",
    "/full_purchase",
    "/full_customer",
    "/full_supplier",
    "/purchase_return",
    "/total_daily_report",
    "/product_serial_no",
    "/product_performance",
    "/stock-report",
    "/raw-material-report",
    "/finished-product-report",
    "/product-transfer",
    "/ingridents",
    "/e_product",
    "/ingredients/:productId",
    "/product-details/:productId",
    "/process/:productId",
    "/share-holders",
    "/share-holders-details",
    "/pobatch-report",
    "/shareholders",
    "/share-holder-payment",
    "/ItemStock_list"
  ];

  const Insecure = (Component) => {
    if (Logindata) {
      return <Navigate to="/dashboard" replace />;
    }
    return (
      <>
        <Component />
      </>
    )
  };

  const routes = [
    { path: "/", element: Insecure(Log) },
    { path: "/login", element: Insecure(Log) },
    { path: "/Emaildata", element: Common(Emaillog) },
    { path: "/dashboard", element: Common(Home) },
    { path: "/Role_list", element: Common(Role_list) },
    { path: "/User_list", element: Common(User_list) },
    { path: "/Warehouse_list", element: Common(Warehouse_list) },
    { path: "/Category_list", element: Common(Category_list) },
    { path: "/Subcategory_list", element: Common(Subcategory_list) },
    { path: "/ItemCategory_list", element: Common(ItemCategory_list) },
    { path: "/Item_list", element: Common(Item_list) },
    { path: "/ItemPurchase", element: Common(ItemPurchase) },
    { path: "/add_item_purchase", element: Common(AddItemPurchase) },
    { path: "/ItemSales", element: Common(ItemSales) },
    { path: "/ItemStock_list", element: Common(ItemStock_list) },
    { path: "/item_sales_list", element: Common(ItemSalesList) },
    { path: "/item_sales_return_list", element: Common(ItemSalesReturnList) },
    { path: "/item_purchase_return_list", element: Common(ItemPurchaseReturnList) },
    { path: "/Supplier_list", element: Common(Supplier_list) },
    { path: "/Product_list", element: Common(Product_list) },
    { path: "/ProductQty_list", element: Common(ProductQty_list) },
    { path: "/Product_profitlose", element: Common(Product_polo_list) },
    { path: "/calender", element: Common(Calender) },
    { path: "/Customers_list", element: Common(Customers_list) },
    { path: "/Customer_receipt", element: Common(Customersre) },
    { path: "/Customer_details", element: Common(Customers_details) },
    { path: "/Manufacturer_list", element: Common(Manufacturers_list) },
    { path: "/chat", element: Common(Chat) },
    { path: "/brands", element: Common(Brand) },
    { path: "/purchase", element: Common(Purchase) },
    { path: "/Quotation_list", element: Common(Quotation_list) },
    { path: "/add_purchase", element: Common(AddPurchase) },
    { path: "/edit_purchase", element: Common(EditPurchase) },
    { path: "/add_inventory", element: Common(PurchaseInventory) },
    { path: "/purchase_pdf", element: Common(PurchasePDF) },
    { path: "/add_quotation", element: Common(AddQuotation) },
    { path: "/edit_quotation", element: Common(EditQuotation) },
    { path: "/quotation_pdf", element: Common(QuotationPDF) },
    { path: "/sales_window", element: Common(SalesWindow) },
    { path: "/return_list", element: Common(ReturnList) },
    { path: "/sales_list", element: Common(SalesList) },
    { path: "/findsale", element: Common(Findsales) },
    { path: "/finance_list", element: Common(FinanceList) },
    { path: "/units", element: Common(Units_list) },
    { path: "/taxes", element: Common(Taxes_list) },
    { path: "/sales_details", element: Common(SalesDetail) },
    { path: "/documents_type", element: Common(Documents_type) },
    { path: "/documents_table", element: Common(DocumentTable) },
    { path: "/documents_details", element: Common(Documents_Details) },
    { path: "/invoice", element: Common(FinanceList) },
    { path: "/credit-receipt", element: Common(CreditReceipt) },
    { path: "/Menu", element: <Navigate to="/dashboard" replace /> },
    { path: "/shops", element: Common(ShopsBranch) },
    { path: "/sub-company", element: Common(SubCompany) },
    { path: "/sub-companys", element: Common(SubCompany) },
    { path: "/shops-branch", element: Common(ShopsBranch) },
    { path: "/branch", element: Common(Branch) },
    { path: "/branch_list", element: Common(BranchList) },
    { path: "/Employee", element: Common(Employee) },
    { path: "/parent_company", element: Common(ParentCompany) },
    { path: "/documentupload", element: Common(DocumentTable) },
    { path: "/reports", element: Common(Reports) },
    { path: "/profitloss-report", element: Common(ProfitLossReport) },
    { path: "/monthly-profitloss-report", element: Common(MonthlyProfitLossReport) },
    { path: "/daily_sales_report", element: Common(DailySalesReport) },
    { path: "/projects_expenses", element: Common(Projectandexpenses) },
    { path: "/projectemployeereport", element: Common(ProjectEmployeeReport) },
    { path: "/profit-loss_report", element: Common(ProfitLoss_report) },
    { path: "/projects", element: Common(Projectsall) },
    { path: "/clients", element: Common(Clinet) },
    { path: "/accounts", element: Common(Account) },
    { path: "/loan-report", element: Common(Loanreport) },
    { path: "/employee_report", element: Common(Emp_report) },
    { path: "/expiry_items_report", element: Common(Expiry_report) },
    { path: "/income_expense_report", element: Common(inexpe_report) },
    { path: "/purchase-report", element: Common(PurchaseReport) },
    { path: "/stocks_report", element: Common(Stock_report) },
    { path: "/credit_debit_report", element: Common(Creditdebit_report) },
    { path: "/sales_report", element: Common(SalesReport) },
    { path: "/inventory", element: <Navigate to="/full_product" replace /> },
    { path: "/raw_metrial", element: Common(Rawmaterial) },
    { path: "/full_product", element: Common(Full_product) },
    { path: "/full_purchase", element: Common(Full_purchase) },
    { path: "/full_customer", element: Common(Full_customer) },
    { path: "/full_supplier", element: Common(Full_supplier) },
    { path: "/full_sales", element: Common(Full_sales) },
    { path: "/return_list_order", element: Common(ReturnListorder) },
    { path: "/rm_sales_list", element: Common(RMSalesList) },
    { path: "/rm_return_list_order", element: Common(RMReturnListorder) },
    { path: "/project_todo", element: Common(Project_todo) },
    { path: "/expense", element: Common(Expense) },
    { path: "/capital", element: Common(Expense) },
    { path: "/accounts_list", element: Common(CompanyReport) },
    { path: "/Company_accounts", element: Common(Accountlist) },
    { path: "/UserDocument", element: Common(UserDocument) },
    { path: "/Supplier_receipt", element: Common(Supplier_receipt1) },
    { path: "/Supplier_details", element: Common(Supplier_details1) },
    { path: "/Client_feedback", element: Common(Client_Feedback) },
    { path: "/Rawmetrial_expiry", element: Common(Expiry) },
    { path: "/supplier-transaction", element: Common(SupplierTransaction) },
    { path: "/customr-transaction", element: Common(CustomerTransaction) },
    { path: "/finance-report", element: Common(FinanceReport) },
    { path: "/daily_sales-report_details", element: Common(DailysalesReportDetails) },
    { path: "/service-transaction", element: Common(ServiceTransaction) },
    { path: "/service-report", element: Common(ServiceReport) },
    { path: "/shopdata", element: Common(shopdata) },
    { path: "/crm-menu", element: Common(CRMMenu) },
    { path: "/terms", element: Common(Termsandcondiitons) },
    { path: "/employee-management", element: <Navigate to="/user_list" replace /> },
    { path: "/SalesReport_Pdf", element: Common(SalesReport_PDF) },
    { path: "/return", element: Common(Return) },
    { path: "/purchase_return", element: Common(PurchaseReturn) },
    { path: "/total_daily_report", element: Common(Totaldailyreport) },
    { path: "/product_serial_no", element: Common(ProductSerialNo) },
    { path: "/product_performance", element: Common(ProductPerformance) },
    { path: "/purchase-return-list", element: Common(PurchasesReturnReport) },
    { path: "/general-ledger", element: Common(GeneralLedger) },
    { path: "/all-transaction", element: Common(AllTransaction) },
    { path: "/stock-report", element: Common(StockReport) },
    { path: "/raw-material-report", element: Common(RawMaterialReport) },
    { path: "/finished-product-report", element: Common(FinishedProductReport) },
    { path: "/product-transfer", element: Common(ProductTransfer) },
    { path: "/product_master", element: Common(product_master) },
    { path: "/raw_materials", element: Common(RawMaterials) },
    { path: "/packaging_materials", element: Common(RawMaterials) },
    { path: "/ingridents", element: Common(ProductProcessingList) },
    { path: "/e_product", element: Common(Eproduct) },
    { path: "/raw_transection", element: Common(Raw_transection) },
    { path: "/product_expire", element: Common(product_expire) },
    { path: "/e_product_process", element: Common(Product_process) },
    { path: "/product_order", element: Common(Product_order) },
    { path: "/raw_material_order", element: Common(RawMaterialOrder) },
    { path: "/Product_master_details", element: Common(Pod_details) },

    { path: "/ingredients/:productId", element: Common(IngredientsPage) },
    { path: "/product-details/:productId", element: Common(ProductDetailsPage) },
    { path: "/process/:productId", element: Common(ProcessPage) },
    { path: "/product-detail-transaction", element: Common(ProductDetailTransaction) },
    { path: "/undistributed-products", element: Common(UndistributedProducts) },
    { path: "/share-holders", element: Common(ShareHolderList) },
    { path: "/share-holders-details", element: Common(ShareHolderDetails) },
    { path: "/pobatch-report", element: Common(POBatchreport) },
    { path: "/shareholders", element: Common(Shareholders) },
    { path: "/share-holder-payment", element: Common(Sharepaymentreport) },
    { path: "/salary_list", element: Common(SalaryList) },
    { path: "/advance_report", element: Common(AdvanceReport) },
    { path: "/bank", element: Common(BankLedger) },
    { path: "/equity", element: Common(Equity) },
    { path: "/assets", element: Common(Assets) },


  ];

  //   const filteredRoutes = routes.filter((route) =>
  //   routeList.includes(route.path)
  // );

  const filteredRoutes = routes.filter((route) => {
    const role = Logindata?.user?.role_title?.toLowerCase();
    if (role === 'super admin' || role === 'admin') return true;
    return routeList.includes(route.path);
  });

  return (
    <Router>
      <Routes>
        {filteredRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
      {/* <ToastContainer /> */}
    </Router>
  );
}

export default App;
